import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/databases/state'
import Databases from 'redux/databases/databases.duck'
import DatabasesGridSession from 'redux/databases/gridSession.duck'

export default composeReducers(
  createReducerFunction(Databases, defaultState),
  createReducerFunction(DatabasesGridSession, defaultState)
)
